'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FolderNavCreateFolderFooter = ({
  onSaveFolder,
  onFolderOpenChange
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(Button, {
    use: "tertiary",
    size: "extra-small",
    onClick: onSaveFolder,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.folderModal.create.save"
    })
  }), /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    size: "extra-small",
    onClick: () => onFolderOpenChange(false),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.folderModal.create.cancel"
    })
  })]
});
FolderNavCreateFolderFooter.propTypes = {
  onSaveFolder: PropTypes.func.isRequired,
  onFolderOpenChange: PropTypes.func.isRequired
};
export default FolderNavCreateFolderFooter;